import React, { useState } from 'react';

// Import thumbnails
import screen1Thumbnail from '../../../assets/images/FnSPressKit/thumbnails/screen1-thumbnail.jpg';
import screen1Full from '../../../assets/images/FnSPressKit/screen1_proto.png';

import screen2Thumbnail from '../../../assets/images/FnSPressKit/thumbnails/screen2-thumbnail.jpg';
import screen2Full from '../../../assets/images/FnSPressKit/screen2_proto.png';

import screen3Thumbnail from '../../../assets/images/FnSPressKit/thumbnails/screen3-thumbnail.jpg';
import screen3Full from '../../../assets/images/FnSPressKit/screen3_proto.png';

import illustration2Thumbnail from '../../../assets/images/FnSPressKit/thumbnails/Illustration_2-thumbnail.jpg';
import illustration2Full from '../../../assets/images/FnSPressKit/Illustration_2.png';

import hotshot4Thumbnail from '../../../assets/images/FnSPressKit/thumbnails/Hotshot4-thumbnail.jpg';
import hotshot4Full from '../../../assets/images/FnSPressKit/Hotshot4.png';

import hotshotSelectedThumbnail from '../../../assets/images/FnSPressKit/thumbnails/HotshotSelected-thumbnail.jpg';
import hotshotSelectedFull from '../../../assets/images/FnSPressKit/HotshotSelected.png';

import swarmhighlightedThumbnail from '../../../assets/images/FnSPressKit/thumbnails/Swarmhighlighted-thumbnail.jpg';
import swarmhighlightedFull from '../../../assets/images/FnSPressKit/Swarmhighlighted.png';

import swarmSelectedThumbnail from '../../../assets/images/FnSPressKit/thumbnails/SwarmSelected-thumbnail.jpg';
import swarmSelectedFull from '../../../assets/images/FnSPressKit/SwarmSelected.png';

import tracyConceptsThumbnail from '../../../assets/images/FnSPressKit/thumbnails/screen3-thumbnail.png';
import tracyConceptsFull from '../../../assets/images/FnSPressKit/Tracy Concepts.png';

import canonThumbnail from '../../../assets/images/FnSPressKit/thumbnails/canon_thumbnail.jpg';
import canonFull from '../../../assets/images/FnSPressKit/021_Cannon Ball.jpg';

import defendThumbnail from '../../../assets/images/FnSPressKit/thumbnails/defend_thumbnail.jpg';
import defendFull from '../../../assets/images/FnSPressKit/004_Defend.jpg';

import mobThumbnail from '../../../assets/images/FnSPressKit/thumbnails/mob_thumbnail.jpg';
import mobFull from '../../../assets/images/FnSPressKit/026_MOb.jpg';

import dronesThumbnail from '../../../assets/images/FnSPressKit/thumbnails/Drones3-thumbnail.jpg';
import dronesFull from '../../../assets/images/FnSPressKit/Drones3.png';

import coverartThumbnail from '../../../assets/images/FnSPressKit/thumbnails/Coverart-thumbnail.jpg';
import coverartFull from '../../../assets/images/FnSPressKit/Coverart.png';

import cielConceptsThumbnail from '../../../assets/images/FnSPressKit/thumbnails/CielConcepts-thumbnail.jpg';
import cielConceptsFull from '../../../assets/images/FnSPressKit/CielConcepts.png';

import './FnSpressKitGallery.css';

const FnSpressKitGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [preloadedImages, setPreloadedImages] = useState({});
    // Reset zoom and position when closing the viewer
  const handleClose = () => {
    setSelectedImage(null);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };
  // Handle keyboard events
  const handleKeyDown = (e) => {
    if (!selectedImage) return;
    
    switch (e.key) {
      case 'Escape':
        handleClose();
        break;
      case '+':
      case '=':
        setZoom(prevZoom => Math.min(3, prevZoom + 0.25));
        setPosition({ x: 0, y: 0 });
        break;
      case '-':
        setZoom(prevZoom => Math.max(1, prevZoom - 0.25));
        setPosition({ x: 0, y: 0 });
        break;
      default:
        break;
    }
  };  // Preload an image
  const preloadImage = (src) => {
    if (!preloadedImages[src]) {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        setPreloadedImages(prev => ({
          ...prev,
          [src]: true
        }));
      };
    }
  };

  // Handle image click to open the viewer
  const handleImageClick = (image) => {
    setIsLoading(true);
    setSelectedImage(image);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
    
    // Preload adjacent images for smoother navigation
    const currentIndex = imageItems.findIndex(item => item.full === image.full);
    if (currentIndex > -1) {
      // Preload next image
      if (currentIndex < imageItems.length - 1) {
        preloadImage(imageItems[currentIndex + 1].full);
      }
      // Preload previous image
      if (currentIndex > 0) {
        preloadImage(imageItems[currentIndex - 1].full);
      }
    }
  };

  // Handle zoom with mouse wheel
  const handleWheel = (e) => {
    if (!selectedImage) return;
    
    e.preventDefault();
    const delta = e.deltaY * -0.01;
    const newZoom = Math.max(1, Math.min(3, zoom + delta));
    setZoom(newZoom);
  };
    // Handle click on the lightbox image to toggle zoom
  const handleImageToggleZoom = (e) => {
    e.stopPropagation();
    setZoom(zoom === 1 ? 2 : 1);
    setPosition({ x: 0, y: 0 });
  };
  // Handle mouse down for dragging
  const handleMouseDown = (e) => {
    if (zoom > 1) {
      setIsDragging(true);
      setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
    }
  };

  // Handle touch start for mobile dragging
  const handleTouchStart = (e) => {
    if (zoom > 1 && e.touches && e.touches[0]) {
      setIsDragging(true);
      setDragStart({ 
        x: e.touches[0].clientX - position.x, 
        y: e.touches[0].clientY - position.y 
      });
    }
  };

  // Handle mouse move for dragging
  const handleMouseMove = (e) => {
    if (isDragging && zoom > 1) {
      const newX = e.clientX - dragStart.x;
      const newY = e.clientY - dragStart.y;
      setPosition({ x: newX, y: newY });
    }
  };

  // Handle touch move for mobile dragging
  const handleTouchMove = (e) => {
    if (isDragging && zoom > 1 && e.touches && e.touches[0]) {
      e.preventDefault(); // Prevent scrolling while dragging
      const newX = e.touches[0].clientX - dragStart.x;
      const newY = e.touches[0].clientY - dragStart.y;
      setPosition({ x: newX, y: newY });
    }
  };

  // Handle mouse up to end dragging
  const handleMouseUp = () => {
    setIsDragging(false);
  };
  
  // Handle touch end to end dragging on mobile
  const handleTouchEnd = () => {
    setIsDragging(false);
  };
  // Double-click to toggle between zoom 1 and zoom 3 (higher than single-click)
  const handleDoubleClick = () => {
    setZoom(zoom === 1 ? 3 : 1);
    setPosition({ x: 0, y: 0 });
  };

  // Download the full-size image
  const handleDownload = () => {
    if (selectedImage) {
      const link = document.createElement('a');
      link.href = selectedImage.full;
      link.download = selectedImage.alt || 'image';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const imageItems = [
    { thumbnail: screen1Thumbnail, full: screen1Full, alt: 'Game Screenshot 1', width: 1920, height: 1080 },
    { thumbnail: screen2Thumbnail, full: screen2Full, alt: 'Game Screenshot 2', width: 1920, height: 1080 },
    { thumbnail: screen3Thumbnail, full: screen3Full, alt: 'Game Screenshot 3', width: 1920, height: 1080 },
    { thumbnail: illustration2Thumbnail, full: illustration2Full, alt: 'Illustration 2', width: 1920, height: 1080 },
    { thumbnail: hotshot4Thumbnail, full: hotshot4Full, alt: 'Hotshot 4', width: 1920, height: 1080 },
    { thumbnail: hotshotSelectedThumbnail, full: hotshotSelectedFull, alt: 'Hotshot Selected', width: 1920, height: 1080 },
    { thumbnail: swarmhighlightedThumbnail, full: swarmhighlightedFull, alt: 'Swarm Highlighted', width: 1920, height: 1080 },
    { thumbnail: swarmSelectedThumbnail, full: swarmSelectedFull, alt: 'Swarm Selected', width: 1920, height: 1080 },
    { thumbnail: tracyConceptsThumbnail, full: tracyConceptsFull, alt: 'Tracy Concepts', width: 1920, height: 1080 },
    { thumbnail: canonThumbnail, full: canonFull, alt: 'Canon Ball', width: 1920, height: 1080 },
    { thumbnail: defendThumbnail, full: defendFull, alt: 'Defend', width: 1920, height: 1080 },
    { thumbnail: mobThumbnail, full: mobFull, alt: 'Mob', width: 1920, height: 1080 },
    { thumbnail: dronesThumbnail, full: dronesFull, alt: 'Drones', width: 1920, height: 1080 },
    { thumbnail: coverartThumbnail, full: coverartFull, alt: 'Cover Art', width: 1920, height: 1080 },
    { thumbnail: cielConceptsThumbnail, full: cielConceptsFull, alt: 'Ciel Concepts', width: 1920, height: 1080 },
  ];

  return (
    <>
      <div className="gallery-grid">
        {imageItems.map((item, index) => (
          <div key={index} className="gallery-item">            <img
              onClick={() => handleImageClick(item)}
              src={item.thumbnail}
              alt={item.alt}
              className="gallery-thumbnail"
            />
          </div>
        ))}
      </div>      {selectedImage && (
        <div 
          className="custom-lightbox fade-in" 
          onClick={handleClose}
          onWheel={handleWheel}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        >
          <div className="custom-lightbox-content" onClick={(e) => e.stopPropagation()}>
            {imageItems.length > 1 && (
              <>
                <button className="nav-button prev-button" onClick={(e) => {
                  e.stopPropagation();
                  const currentIndex = imageItems.findIndex(item => item.full === selectedImage.full);
                  const newIndex = currentIndex > 0 ? currentIndex - 1 : imageItems.length - 1;
                  handleImageClick(imageItems[newIndex]);
                }}>
                  <span>&lt;</span>
                </button>
                <button className="nav-button next-button" onClick={(e) => {
                  e.stopPropagation();
                  const currentIndex = imageItems.findIndex(item => item.full === selectedImage.full);
                  const newIndex = currentIndex < imageItems.length - 1 ? currentIndex + 1 : 0;
                  handleImageClick(imageItems[newIndex]);
                }}>
                  <span>&gt;</span>
                </button>
              </>
            )}            <div 
              className="custom-lightbox-image-container" 
              onMouseDown={handleMouseDown}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              onDoubleClick={handleDoubleClick}
              onClick={(e) => e.stopPropagation()}
            >
              {isLoading && (
                <div className="loading-spinner">
                  <div className="spinner"></div>
                </div>
              )}              <img
                src={selectedImage.full}
                alt={selectedImage.alt}
                className={`custom-lightbox-image ${isLoading ? 'loading' : 'loaded'}`}
                onClick={handleImageToggleZoom} 
                onLoad={() => setIsLoading(false)}
                style={{
                  transform: `translate(${position.x}px, ${position.y}px) scale(${zoom})`,
                  cursor: zoom > 1 ? (isDragging ? 'grabbing' : 'grab') : 'zoom-in'
                }}
              />
            </div>
            <div className="custom-lightbox-controls">
              <div className="custom-lightbox-info">
                <h3>{selectedImage.alt}</h3>
                <p>{selectedImage.width} x {selectedImage.height}px</p>
              </div>
              <div className="custom-lightbox-buttons">
                <button className="download-btn" onClick={handleDownload}>Download</button>
                <button className="close-btn" onClick={handleClose}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FnSpressKitGallery;